// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration - beta
// const firebaseConfig = {
//   apiKey: "AIzaSyCRrBJdgAqg8NeDQNSm33sh_IvqmuXhAUE",
//   authDomain: "ucena-ef8cb.firebaseapp.com",
//   projectId: "ucena-ef8cb",
//   storageBucket: "ucena-ef8cb.firebasestorage.app",
//   messagingSenderId: "524190473546",
//   appId: "1:524190473546:web:0f91377afc294b95a2f5b3"
// };

// // // Your web app's Firebase configuration - production
const firebaseConfig = {
  apiKey: "AIzaSyBjDy3E3vZoxQnQMw__vTHN3VV76lAGeVM",
  authDomain: "ucena-app.firebaseapp.com",
  projectId: "ucena-app",
  storageBucket: "ucena-app.firebasestorage.app",
  messagingSenderId: "938875255729",
  appId: "1:938875255729:web:7c4bf7ee9b14c648bddb90",
  measurementId: "G-3NK88LVRPT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app; 
